// ----------------------------------------------------------------------
// <copyright file="Izenda.AdvancedCopyToolbar.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * AdvancedCopyToolbar component
 */
!(function() {


  var React = require('react');
  var observer = require('mobx-react').observer;
  var connect = require('share/enhancers/Izenda.Connect');
  var constants = require('logic/data/Izenda.CopyManagementConstants');

  var IconMenu = require('share/components/controls/Izenda.IconMenu');
  var ActionButton = require('share/components/controls/Izenda.ActionButton');
  var Button = require('share/components/controls/Izenda.Button');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Alert = require('share/components/controls/Izenda.Alert');
  const { isEmpty, isNil } = require('lodash/fp');

  var AdvancedCopyToolbar = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    render: function() {
      var store = this.props.store;
      var item = store.item;
      var alertMessage = this.props.store.item.alertMessage;
      var localization = this.props.localization;

      return (
        <div className="izenda-Wrapper-header">
          <IconMenu />

          <Alert type={alertMessage.type} className="pull-left">
            {alertMessage.message}
          </Alert>

          <div className="izenda-ActionBarRight">
            <ActionButton>
              <Button
                label={localization.getText('COPY_MANAGEMENT_LABEL_REFRESH')}
                onClick={this.refreshWorkspaceTenant}
              />
              <Button
                label={localization.getText('COPY_MANAGEMENT_LABEL_VALIDATE')}
                onClick={this.onValidate}
                className="btn-success"
                disabled={item.selectedTenant.status === constants.STATUS_OF_DESTINATION.READY_TO_COPY}
              />
            </ActionButton>
            <Button label={localization.getText('COMMON_LABEL_OK')} onClick={item.updateWorkspaceTenant.bind(item)} />
            <Button
              label={localization.getText('COMMON_LABEL_CANCEL')}
              onClick={item.setSelectedTenant.bind(item, null)}
            />
          </div>
        </div>
      );
    },

    /**
     * handle validate event
     */
    onValidate: function() {
      var props = this.props;
      var valManager = props.validation;
      var loader = props.loader;

      // Run validate
      valManager
        .validate()
        .then(
          function(success) {
            if (success) {
              loader.startLoading();
              return this.handleValidation();
            }
          }.bind(this)
        )
        .finally(loader.endLoading.bind(loader));
    },

    /**
     * handle validation error
     */
    handleValidation: function() {
      var props = this.props;
      var valManager = props.validation;

      return props.store
        .validateWorkspaceTenant(null, true)
        .bind(this)
        .then(function(result) {
          if (isNil(result.workspaceTenant)) {
            !isEmpty(result.messages) && isEmpty(result.messages[0].key)
              ? this.hanldeConcurrency(result)
              : valManager.updateErrors(result.messages);
            return null;
          }
        });
    },

    hanldeConcurrency: function(result) {
      var props = this.props;
      var valManager = props.validation;
      var loader = props.loader;

      // show pop up confirmation
      return props
        .confirmFn('Confirmation', {
          description: result.messages[0].messages[0],
          showCancel: false
        })
        .then(function() {
          loader.startLoading();
          props.store.handleAfterConcurrency(result.messages[0].detail).finally(loader.endLoading.bind(loader));
        });
    },

    refreshWorkspaceTenant: function() {
      var props = this.props;
      var loader = props.loader;

      loader.startLoading();
      props.store.checkHashCodeSource().finally(loader.endLoading.bind(loader));
    }
  });

  module.exports = connect()(AdvancedCopyToolbar);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/AdvancedCopy/Izenda.AdvancedCopyToolbar.jsx